module.exports = __webpack_public_path__ + "media/images/logo-38b5471a7be2e5f20d933919d063ee73.png";